import { render } from "./RolesManager.vue?vue&type=template&id=4b00da24"
import script from "./RolesManager.vue?vue&type=script&lang=js"
export * from "./RolesManager.vue?vue&type=script&lang=js"
script.render = render

export default script